export default {
  FETCH_CATEGORIES: 'fetchCategories',
  FETCH_RESULTS: 'fetchResults',
};
